import React from 'react';
import { Button } from 'design-system-web';
import { useTranslation } from 'react-i18next';
import styles from './LoadSettingButton.scss';

type LoadSettingButtonProps = {
  loading?: boolean;
  error?: string;
  callback: () => void;
  disabled: boolean;
  textContent?: string;
  doTranslation?: boolean;
};

export function LoadSettingButton({
  loading,
  error,
  callback,
  disabled,
  textContent = 'web.admin.channel.integrations.vantify.settings.load-settings',
  doTranslation = true,
}: LoadSettingButtonProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.property}>
      <Button
        variant="secondary"
        size="large"
        loading={loading}
        onClick={() => callback()}
        testId="buttonLoadMetadataFields"
        disabled={disabled}
      >
        {doTranslation ? t(textContent) : textContent}
      </Button>
      {error ? (
        <div className={styles.bottomBox}>
          <p key={error} className={styles.error} data-testid="errorMessage">
            {error}
          </p>
        </div>
      ) : null}
    </div>
  );
}
